<template>
  <div
    class="service-item-container normal-button"
    v-bind:class="{
      active: isSelected,
      left: index % 3 == 0,
      center: index % 3 == 1,
      right: index % 3 == 2,
    }"
    @click="onClick"
  >
    <span class="title" v-bind:class="{ 'title-active': isSelected }">{{
      title
    }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      isRequired: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      isRequired: true,
    },
  },
  methods: {
    onClick() {
      this.$emit("onItemClick");
    },
  },
};
</script>

<style lang="scss" scoped>
$spacing: 4.5px;
.active {
  background-color: #ac9052 !important;
  border: none;
}
.title-active {
  color: white;
}
.title {
  font-weight: 600;
  font-size: 14px;
}
.left {
  margin-right: $spacing;
}
.right {
  margin-left: $spacing;
}
.center {
  margin-left: $spacing;
  margin-right: $spacing;
}
.service-item-container {
  display: flex;
  align-items: center;
  padding: 0 8px;
  margin-bottom: 9px;
  border: 1.5px solid #eeeeee;
  background-color: #f9f7f1;
  border-radius: 6px;
  width: calc(33% - 6px);
  height: 50px;
  .icon {
    height: 25px;
    width: auto;
    margin-left: 15px;
  }
}
</style>